"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseTransform_1 = require("./BaseTransform");
var Query_1 = require("../Query");
var object_1 = require("../../utils/object");
var typeChecks_1 = require("../../utils/typeChecks");
var CollectionTransform = /** @class */ (function (_super) {
    __extends(CollectionTransform, _super);
    function CollectionTransform() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CollectionTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
        var response = [];
        var _a = this.options, parentOptionsFields = _a.fields, _b = _a.collectionTransformOptions, collectionTransformOptions = _b === void 0 ? {} : _b;
        if (queryResponse) {
            var fields = collectionTransformOptions.fields || parentOptionsFields || [];
            var singleFieldValueKey_1 = collectionTransformOptions.singleFieldValueKey, _c = collectionTransformOptions.type, type = _c === void 0 ? 'standard' : _c, mergeKey_1 = collectionTransformOptions.mergeKey;
            var hasSingleFieldValueKey = singleFieldValueKey_1 && singleFieldValueKey_1.length > 0;
            if (type === 'standard') {
                for (var _i = 0, queryResponse_1 = queryResponse; _i < queryResponse_1.length; _i++) {
                    var queryResponseRow = queryResponse_1[_i];
                    var row = __assign({}, queryResponseRow);
                    var workingExecutionOptions = object_1.deepMergeObjects(executionOptions, { responseContext: row });
                    for (var _d = 0, fields_1 = fields; _d < fields_1.length; _d++) {
                        var field = fields_1[_d];
                        var _e = field, originalKey = _e.key, query = _e.query, keyQueryOptions = _e.keyQuery;
                        var key = originalKey;
                        if (!originalKey && keyQueryOptions) {
                            var keyQuery = new Query_1.Query(keyQueryOptions);
                            key = keyQuery.execute(workingExecutionOptions);
                        }
                        if (!hasSingleFieldValueKey || singleFieldValueKey_1 === key) {
                            if (query) {
                                var valueQuery = new Query_1.Query(query);
                                var value = valueQuery.execute(workingExecutionOptions);
                                row[key] = value;
                            }
                        }
                    }
                    response.push(row);
                }
                if (hasSingleFieldValueKey) {
                    response = response.map(function (row) { return row[singleFieldValueKey_1]; });
                }
            }
            if (type === 'merge' && mergeKey_1) {
                var rowByKey = queryResponse.reduce(function (acc, row) {
                    var keyValue = row[mergeKey_1];
                    if (!typeChecks_1.isNullOrUndefined(keyValue)) {
                        acc[keyValue] = object_1.deepMergeObjects(acc[keyValue] || {}, row);
                    }
                    return acc;
                }, {});
                response = Object.values(rowByKey);
            }
            if (type === 'flatten') {
                response = queryResponse.reduce(function (acc, row) {
                    if (Array.isArray(row)) {
                        acc.push.apply(acc, row);
                    }
                    else {
                        acc.push(row);
                    }
                    return acc;
                }, []);
            }
        }
        return response;
    };
    return CollectionTransform;
}(BaseTransform_1.BaseTransform));
exports.CollectionTransform = CollectionTransform;
//# sourceMappingURL=CollectionTransform.js.map